import {
    Box,
    Button,
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useDisclosure
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import { Link } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import {
    DoctorSignupForm,
    IDoctorSignupFormValues,
    ISpecialistSignupFormValues,
    SpecialistSignupForm
} from "../../forms";
import {
    AccountRole,
    AccountsDocument,
    DoctorProfile,
    useAccountsQuery,
    useDoctorSignupMutation,
    useSpecialistSignupMutation
} from "../../graphql";
import { useAccounts } from "../../hooks";
import { formatDateTime } from "../../utils";
import { AccountsFilter } from "../Patients";

const Specialists: React.FC = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    // const accountQueryVariables = {
    //   role: AccountRole.MedicalSpecialist,
    //   page: 1,
    //   pageLimit: 1000,
    // };

    // const { data, loading } = useAccountsQuery({
    //   variables: accountQueryVariables,
    // });

    const {
        items,
        loading,
        totalCount,
        hasNextPage,
        loadMore,
        refresh
    } = useAccounts(AccountRole.MedicalSpecialist, "");

    const [doctorSignup] = useSpecialistSignupMutation();

    const handleSignup = async (client: ISpecialistSignupFormValues) => {
        await doctorSignup({
            variables: {
                birthday: client.birthday,
                cityId: parseInt(client.cityId),
                countryId: parseInt(client.countryId),
                email: client.email,
                healthCenterId: parseInt(client.healthCenterId),
                languageCode: client.languageCode,
                lastname: client.lastname,
                licenceNumber: client.licenceNumber,
                name: client.name,
                password: "abc",
                phoneNumber: client.phoneNumber,
                sex: client.sex,
                bio: "",
                specialityId: parseInt(client.specialityId)
            }
        });

        refresh({ search: "" });

        onClose();
    };

    return (
        <>
            <Modal
                closeOnOverlayClick={ false }
                isOpen={ isOpen }
                onClose={ onClose }
                size="xl"
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Shto një mjek</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <SpecialistSignupForm onSubmit={ (doctor) => handleSignup(doctor) } />
                    </ModalBody>
                </ModalContent>
            </Modal>
            <>
                <Box
                    borderWidth="1px"
                    borderRadius="lg"
                    overflow="hidden"
                    p={ 2 }
                    background="white"
                >
                    <Title title="Lista e mjekëve specialistë">
                        <HStack>
                            <AccountsFilter
                                onChange={ (data) => {
                                    refresh({ search: data.term });
                                } }
                            />
                            <Button
                                colorScheme="blue"
                                size="sm"
                                variant="ghost"
                                leftIcon={ <MdAdd /> }
                                onClick={ onOpen }
                            >
                                Shto mjek
                            </Button>
                        </HStack>
                    </Title>

                    { loading ? (
                        <Loader />
                    ) : (
                        <Table variant="striped" size="sm">
                            <Thead>
                                <Tr>
                                    <Th>Emri</Th>
                                    <Th>E-mail</Th>
                                    <Th>Telefoni</Th>
                                    <Th>Qëndra shëndetsore</Th>
                                    <Th>Qyteti</Th>
                                    <Th>Shteti</Th>
                                    <Th>Numri i liçensës</Th>
                                    <Th>Specialiteti</Th>
                                    <Th isNumeric>Data e rregjistrimit</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                { items?.map((account) => (
                                    <Tr key={ account.id }>
                                        <Td>
                                            <Link to={ `/account/${account.id}` }>
                                                <AccountAvatar
                                                    account={ account }
                                                    role={ false }
                                                    size="xs"
                                                />
                                            </Link>
                                        </Td>
                                        <Td>{ account.email }</Td>
                                        <Td>{ account.phoneNumber }</Td>
                                        <Td>
                                            { (account.profile as DoctorProfile)?.healthCenter?.name }
                                        </Td>

                                        <Td>{ (account.profile as DoctorProfile)?.city?.name }</Td>

                                        <Td>{ (account.profile as DoctorProfile)?.country?.name }</Td>

                                        <Td>{ (account.profile as DoctorProfile)?.licenceNumber }</Td>

                                        <Td>
                                            { (account.profile as DoctorProfile)?.speciality.name }
                                        </Td>

                                        <Td isNumeric>{ formatDateTime(account.createdAt) }</Td>
                                    </Tr>
                                )) }
                            </Tbody>
                        </Table>
                    ) }
                </Box>
            </>
        </>
    );
};

export default Specialists;
